import { Metric } from './EvidenceTables'
import FeedbackError from './FeedbackError'

import styles from './PrereadFeedback.module.scss'

import type { PrereadRatingBucket, PrereadRatingStats } from '@/api/prereadFeedback'
import RatingTrend from '@/components/RatingTrend'
import { percent } from '@/utils'

type Props = {
  since: string
  until: string
  bucket: PrereadRatingBucket
  stats: PrereadRatingStats | undefined
  isError: boolean
  onBucket: (bucket: PrereadRatingBucket) => void
  onRetry: () => void
}

const ReportRatings = ({ since, until, bucket, stats, isError, onBucket, onRetry }: Props) => {
  if (isError) return <FeedbackError onRetry={onRetry} />
  const counts = stats?.overall
  return (
    <>
      <section className={styles.metrics} aria-label="Preread rating metrics" aria-busy={!stats}>
        <Metric label="Thumbs-up rate" value={counts ? percent(counts.pctUp) : '—'} />
        <Metric label="Thumbs up" value={counts?.up ?? '—'} />
        <Metric label="Thumbs down" value={counts?.down ?? '—'} />
        <Metric label="Total ratings" value={counts?.total ?? '—'} />
      </section>
      <RatingTrend
        since={since}
        until={until}
        bucket={bucket}
        onBucket={onBucket}
        series={[{ key: 'current', label: 'Current filters', stats }]}
      />
    </>
  )
}

export default ReportRatings
